import { useId } from 'react'

interface RadioButtonProps {
	name?: string
	checked: boolean
	label: string
	value: string
	onClick: (value: string) => void
}

export default function RadioButton({
	name,
	checked,
	label,
	value,
	onClick,
}: RadioButtonProps) {
	const id = useId()
	const handleClick = (e: React.ChangeEvent<HTMLInputElement>) => {
		onClick(e.target.value)
	}
	return (
		<div className="flex items-center">
			<input
				checked={checked}
				id={id}
				type="radio"
				value={value}
				name={name}
				onChange={handleClick}
				className="form-radio h-5 w-5 border-border accent-secondary"
			/>
			<label htmlFor={id} className="ml-2 text-sm font-medium">
				{label}
			</label>
		</div>
	)
}
